//      
                                              
                                                                   
import { add, subtract } from '../../position';
import withViewportDisplacement from '../../with-scroll-change/with-viewport-displacement';

              
                                
                                
                     
   

export default ({
  pageBorderBoxCenter,
  draggable,
  viewport,
}      )           => {
  const withoutPageScrollChange           = withViewportDisplacement(
    viewport,
    pageBorderBoxCenter,
  );

  const offset           = subtract(
    withoutPageScrollChange,
    draggable.page.borderBox.center,
  );

  return add(draggable.client.borderBox.center, offset);
};



// WEBPACK FOOTER //
// ./src/components/react-beautiful-dnd/state/get-center-from-impact/get-client-border-box-center/get-client-from-page-border-box-center.js